import type { Prisma } from "../../../";

export const setTypeOrderByStatement: Prisma.SetOrderByWithRelationInput = {
  releasedAt: "desc",
};
